import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Protects authenticated routes and applies the phase configured in route data.
 * `admin` is deliberately checked in AuthService, so it always bypasses phases.
 */
@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private auth: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (!this.auth.isLoggedIn()) {
      return this.router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } });
    }

    const requiredPhase = Number(route.data['requiredPhase'] || 0);
    if (!this.auth.canAccessPhase(requiredPhase)) {
      return this.router.createUrlTree(['/extrapages/unauthorized']);
    }

    return true;
  }
}
